/*
 * @Author: shannyHuang
 * @Date: 2022-03-10 19:40:01
 * @LastEditors: brucexlliu
 * @LastEditTime: 2023-07-19 17:11:10
 * @FilePath: \wemeet-web-activity\src\components\AddActivityBtn\index.tsx
 */
import React, { useState, useContext, useCallback, useMemo, useEffect } from 'react';
import { AppContext, ROLETYPE } from '@utils/browser/app-context';
import { useRouter } from 'next/router';
import DashboardEventCreateEvent, {
  Body as CreateActivityParam,
} from '@quickService/DashboardEventCreateEvent';
import { Radio, Form, message, Select, Bubble, Button } from '@tencent/tea-component';
import beaconReport from '@utils/beacon';

import PlusIcon from '@tencent/tpm-meeting-active/lib/Icon/icons/PlusIcon';
import { ACCESS_RULES, CREATE_TICKECT_ARR, PUBLIC_ARR } from '@utils/activity-type/add-option';
import CloseIcon from '@tencent/tpm-meeting-active/lib/Icon/icons/CloseIcon';
import DateTimePicker from '../DateTimePicker';
import ActivityInput from '../ActivityInput';
import styles from './index.module.scss';
import moment from 'moment-timezone';
import IllustrationModal from '@tencent/tpm-meeting-active/lib/IllustrationModal';
import '@tencent/tpm-meeting-active/lib/IllustrationModal/style';
import Link from '@tencent/tpm-meeting-active/lib/Link';
import '@tencent/tpm-meeting-active/lib/Link/style';
import usePaymentQualification from 'src/pages/income/withdraw/hooks/usePaymentQualification';
import { PayBadge } from '@tencent/calendar-web-component-pc-biz';
import UpdateAlert from '@component/UpdateAlert';
import useCommercialize from '@hooks/useCommercialize';
import ActivityTemplateModal from '@component/AddActivityTemplate';
import dataReport from '@utils/data-report';
import { openNewPage } from '@utils/open-new-pgae';
import { defaultTemplateData } from '@component/AddActivityTemplate/useTemplateHooks';
import LabelTips from '@component/LabelTips';
import SingleUpload from '@component//FormCover/SingleImageUpload';
import useDefaultImage from '@hooks/useDefaultImage';
interface AddProps {
  className?: string;
  dataReportCode?: string;
  onSuccessCreate?: Function;
}
// 初始化的活动选项
const defaultActivity = {
  charge_type: 1,
  is_public: 1,
  // schedule_type: 0,
  create_type: 1,
  title: '',
  end_time: 0,
  start_time: 0,
  access_rule: 0,
  template: '',
  cover_image: '', // 封面图 cos_id
  cover_image_url: '', // 封面图 url
};
let isFirst = true;

const AddButton = (props: AddProps) => {
  const { className = '', dataReportCode, onSuccessCreate } = props;
  const [modalState, setModalState] = useState(false);
  const [chargeErr, setChargeErr] = useState(false);
  const { hostDetail, userData } = useContext(AppContext);
  const [dateErrMsg, setDateErrMsg] = useState<React.ReactNode>(''); // 设置时间错误message
  const [dateErrType, setDateErrType] = useState(''); // 设置时间错误类型
  const [addActivityObj, updateActivityObj] = useState<CreateActivityParam>(defaultActivity);
  // 选择主题弹框
  const [templateVisible, updateVisible] = useState(false);
  const defaultImage = useDefaultImage();
  const router = useRouter();
  // 取要执行的动作
  const { action } = router.query;
  const { vipResource, goUpdate, updateConfirm } = useCommercialize();
  const { paid_ticket_switch: paidRole } = vipResource?.rule || {};
  const [createLoading, updateLoading] = useState(false);
  const [showTip, setShowTip] = useState(false);

  // 是否公开显示tips
  const isPublicMessage = useMemo(
    () => PUBLIC_ARR.filter((item) => item.type === String(addActivityObj.is_public))[0].message,
    [addActivityObj?.is_public, PUBLIC_ARR],
  );

  const { hasPaymentQualification } = usePaymentQualification(String(hostDetail?.host_id || ''));
  const minEndDate = useMemo(
    () =>
      addActivityObj.start_time > moment().unix()
        ? moment(addActivityObj.start_time, 'X')
        : moment(),
    [addActivityObj.start_time],
  );

  const chargeMessage = useMemo(() => {
    const type = String(addActivityObj?.charge_type);
    if ((type === '2' || type === '3') && !hasPaymentQualification) {
      setChargeErr(true);
      return (
        <div className={styles.payQualificationLine}>
          <span>检测到您未创建收款账户，无法创建付费活动</span>
          <Link
            size="s"
            type="arrow"
            onClick={() => {
              if (hostDetail?.role_id !== ROLETYPE.CREATED) {
                message.warning({ content: '仅支持活动主办方创建者进行操作' });
                return;
              }
              router.push('/income/manage-settle-in');
              closeModal();
            }}
          >
            立即创建
          </Link>
        </div>
      );
    }
    setChargeErr(false);
    return CREATE_TICKECT_ARR.find((item) => item.value === type)?.message;
  }, [addActivityObj?.charge_type, hasPaymentQualification, hostDetail?.role_id]);

  // 当前收费选项
  const payOption = useMemo(() => {
    const showPaidIcon = !Number(paidRole);
    return CREATE_TICKECT_ARR.map((item) => {
      const disabled = showPaidIcon && item?.value !== '1';
      return {
        ...item,
        text: disabled ? (
          <div className="ma-menu__text ">
            {item?.text}
            <PayBadge type="mid" className="pay-badge"></PayBadge>
          </div>
        ) : (
          <>{item?.text}</>
        ),
      };
    });
  }, [CREATE_TICKECT_ARR, paidRole]);
  // 当前模版类型
  const caption = useMemo(() => {
    if (!addActivityObj?.template) return '新建自定义活动';
    const type = defaultTemplateData.get(addActivityObj?.template)?.title || '';
    return `新建${type}`;
  }, [addActivityObj?.template]);
  const showModal = () => {
    updateVisible(true);
    setShowTip(false);
  };
  // 展示新增弹框
  const chooseTemplate = (item: string) => {
    let template = item;
    if (item === 'custom') template = '';
    updateActivityObj({
      ...defaultActivity,
      cover_image: defaultImage.cos_key,
      cover_image_url: defaultImage.cos_url,
      template,
    });
    setModalState(true);
  };
  const closeModal = () => {
    setModalState(false);
    updateVisible(false);
  };
  const validateTime = (start: any, end: any) => {
    const startDate = moment.unix(start);
    const endDate = moment.unix(end);
    const nowDate = moment();
    const time = Number(vipResource?.end_time || 0);
    if (time && time < end * 1000) {
      setDateErrMsg(
        <>
          <span>活动时间已经超过了版本有效期，请修改活动时间或 </span>
          <span
            className={styles.goUpdate}
            onClick={() => {
              goUpdate();
              closeModal();
            }}
          >
            去续费
          </span>
        </>,
      );
      return false;
    }
    if (endDate < nowDate) {
      setDateErrMsg('结束时间不能早于当前时间');
      setDateErrType('end');
      return false;
    }
    if (startDate < nowDate) {
      setDateErrMsg('开始时间不能早于当前时间');
      setDateErrType('start');
      return false;
    }
    if (endDate <= startDate) {
      setDateErrMsg('活动结束时间应晚于开始时间');
      setDateErrType('end');
      return false;
    }
    setDateErrMsg('');
    setDateErrType('');
    return true;
  };
  // 修改时间选择器
  const onTimeChange = useCallback(
    (start: any, end: any) => {
      updateActivityObj((prev) => ({ ...prev, start_time: start.unix(), end_time: end.unix() }));
      validateTime(start.unix(), end.unix());
    },
    [validateTime],
  );
  /** 1.0版本创建活动 */
  const saveActivity = () => {
    const valiedateBoolean = validateTime(addActivityObj.start_time, addActivityObj.end_time);
    // 当前时间报错按钮置灰
    // 当前标题为空按钮置灰
    if (
      !valiedateBoolean ||
      !addActivityObj.title ||
      (chargeErr && addActivityObj.access_rule === 0)
    )
      return;
    if (createLoading) return;
    updateLoading(true);
    const params = {
      ...addActivityObj,
      host_id: hostDetail?.host_id as string,
    };
    DashboardEventCreateEvent(params).then(
      (res: any) => {
        const { data, code, msg } = res;
        updateLoading(false);
        if (!data?.event_id || code !== 0) {
          message.error({
            content: msg || '创建失败',
          });
          return;
        }
        closeModal();
        message.success({
          content: '创建成功',
        });
        /** 活动创建成功后
         * 1 显示首次跳转弹框
         * 如果在活动列表页，通知活动列表页刷新
         */
        onSuccessCreate?.();
        localStorage.setItem(`${data?.event_id}_guide`, '1');
        // 跳转到管理页面显示 创建成功toast
        /** sessionstorage 设置在当前标签页，
         * 新开页会复制当前页的session
         * 但是新开页删除不会删除根页面的session
         * 所以会导致根页面不关闭的情况下，每次打开都会弹出创建成功 */
        localStorage.setItem(`showToast${data?.event_id}`, '1');
        openNewPage(`/events/host/event/${data?.event_id}`);
      },
      (err) => {
        updateLoading(false);
        if (typeof err === 'string') {
          message.error({ content: err });
          return;
        }
        message.error({ content: '服务错误' });
      },
    );
  };
  const closeTip = useCallback(() => {
    setShowTip(false);
    localStorage.setItem(`showAddActivityTip${userData?.userid}`, '4');
  }, [setShowTip, userData?.userid]);

  useEffect(() => {
    // 同一账号同一浏览器，出现三次后或手动关闭后不再出现提示
    if (!userData?.userid) return;
    const tip = Number(localStorage.getItem(`showAddActivityTip${userData?.userid}`) || 0);
    if (tip < 3) {
      setShowTip(true);
      localStorage.setItem(`showAddActivityTip${userData?.userid}`, String(tip + 1));
    }
  }, [userData?.userid]);

  useEffect(() => {
    if (modalState) {
      const nowMoment = moment().tz('Asia/Shanghai')?.add(30, 'minute');

      const startTime = nowMoment
        .add(7, 'day')
        .minutes(nowMoment.minutes() >= 30 ? 30 : 0)
        .seconds(0);
      const endTime = moment(startTime).add(120, 'minute');
      updateActivityObj((pre) => ({
        ...pre,
        start_time: startTime.unix(),
        end_time: endTime.unix(),
      }));
      setDateErrMsg('');
      setDateErrType('');
    }
  }, [modalState]);

  useEffect(() => {
    if (action === 'addactivity' && !modalState && defaultImage?.cos_key && isFirst) {
      isFirst = false;
      showModal();
    }
  }, [defaultImage]);
  return (
    <div className={className}>
      <Bubble
        visible={showTip}
        placement="bottom"
        content={
          <div className={styles.bubble}>
            快来发布活动吧～
            <span className={styles.close} onClick={closeTip}>
              <CloseIcon color="#1C1C1C" size={14} />
            </span>
          </div>
        }
      >
        <Button
          type="primary"
          className={className}
          onClick={() => {
            dataReport('e#event_create#all#exposure');
            beaconReport('eventplace_hostview_ management_pc_toolbox_newevent_click', {
              hostid: hostDetail?.host_id,
            });
            /** 新版本的数据上报 */
            if (dataReportCode) {
              dataReport(dataReportCode);
            }
            if (!hostDetail?.host_id) return;
            showModal();
          }}
        >
          <PlusIcon />
          创建活动
        </Button>
      </Bubble>
      <ActivityTemplateModal
        visible={templateVisible}
        chooseTemplate={chooseTemplate}
        closeDrawer={() => updateVisible(false)}
      />
      <IllustrationModal
        visible={modalState}
        caption={caption}
        onClose={() => setModalState(false)}
        imageUrl="http://assets.woa.com/open_proj/proj_qcloud_v2/meeting-active/src/public/illustrationModal/img-illustration.jpg"
      >
        <IllustrationModal.Body>
          <Form className={styles.addForm}>
            <Form.Item label="活动主题" required align="middle">
              <ActivityInput
                placeholder="请输入主题"
                length={127}
                value={addActivityObj.title}
                setValue={(title: string) => {
                  updateActivityObj((prev) => ({ ...prev, title }));
                }}
              />
            </Form.Item>
            <Form.Item
              label="活动时间"
              align="middle"
              required
              status={dateErrMsg ? 'error' : undefined}
              message={dateErrMsg}
              className={`is-error-${dateErrType}`}
            >
              <DateTimePicker
                start={addActivityObj.start_time}
                end={addActivityObj.end_time}
                startDateRange={[
                  moment(),
                  moment()
                    .minutes(moment().minutes() >= 30 ? 30 : 0)
                    .add(vipResource?.rule?.event_duration || 14, 'days')
                    .subtract(1, 'minutes'),
                ]}
                endDateRange={[
                  minEndDate,
                  moment()
                    .minutes(moment().minutes() >= 30 ? 30 : 0)
                    .add(vipResource?.rule?.event_duration || 14, 'days'),
                ]}
                onChange={onTimeChange}
              />
            </Form.Item>
            <Form.Item
              label={
                <LabelTips
                  labelText="封面图"
                  tipText="封面图将会展示在活动报名页、活动大厅、活动广场等场景"
                />
              }
            >
              <SingleUpload
                className={styles.flexLayout}
                tipMessage={
                  <div className={styles.tip2}>
                    <p>建议使用840*440的高清图片，大小在5MB内</p>
                    <p>活动创建后也可以前往「基础信息」处修改封面图</p>
                  </div>
                }
                aspectRatio={21 / 11}
                coverInfo={{
                  cutted: addActivityObj.cover_image_url,
                  cuttedCosId: addActivityObj.cover_image,
                  origin: addActivityObj.cover_image_url,
                  originCosId: addActivityObj.cover_image,
                  position: '',
                }}
                onUploadComplete={(v) => {
                  if (v) {
                    const { cosId, url } = v;
                    updateActivityObj((prev) => ({
                      ...prev,
                      cover_image: cosId,
                      cover_image_url: url,
                    }));
                  }
                }}
              />
            </Form.Item>
          </Form>
          <div className={styles.updateTip}>
            {vipResource?.rule_type === 'free' && (
              <UpdateAlert
                className={styles.updateAlert}
                content={`当前版本不支持创建${vipResource?.rule?.event_duration || 14
                  }天以外的活动，升级后即可创建180天以内的活动`}
                onBtnClick={() => {
                  goUpdate();
                  closeModal();
                }}
              />
            )}
          </div>
          <Form className={styles.addForm}>
            <Form.Item
              label="准入方式"
              message={
                ACCESS_RULES?.find((r) => r.type === String(addActivityObj.access_rule))?.message
              }
            >
              <Radio.Group value={String(addActivityObj.access_rule)}>
                {ACCESS_RULES.map((item) => (
                  <Radio
                    key={item.type}
                    name={item.type}
                    onClick={() => {
                      updateActivityObj({ ...addActivityObj, access_rule: Number(item.type) });
                    }}
                  >
                    {item.label}
                  </Radio>
                ))}
              </Radio.Group>
            </Form.Item>
            {addActivityObj.access_rule === 0 ? (
              <Form.Item
                label="收费类型"
                message={chargeMessage}
                required
                align="middle"
                status={chargeErr ? 'error' : undefined}
              >
                <Select
                  appearance="button"
                  options={payOption}
                  value={String(addActivityObj?.charge_type)}
                  placeholder="请选择收费类型所属类别 (单选)"
                  size="full"
                  matchButtonWidth
                  onChange={(value) => {
                    if (!Number(paidRole) && value !== '1') {
                      updateConfirm(
                        '当前版本不支持该功能',
                        '升级腾讯会议活动至基础版及以上，即可发布付费活动。',
                        () => {
                          closeModal();
                        },
                      );
                      return;
                    }
                    updateActivityObj({ ...addActivityObj, charge_type: Number(value) });
                  }}
                />
              </Form.Item>
            ) : null}
            <Form.Item label="活动可见范围" message={isPublicMessage}>
              <Radio.Group value={String(addActivityObj.is_public)}>
                {PUBLIC_ARR.map((item, index) => (
                  <Radio
                    key={index}
                    name={item.type}
                    onClick={() => {
                      // 设置切换显示message与当前是否公开
                      updateActivityObj({ ...addActivityObj, is_public: Number(item.type) });
                    }}
                  >
                    {item.label}
                  </Radio>
                ))}
              </Radio.Group>
            </Form.Item>
          </Form>
        </IllustrationModal.Body>
        <IllustrationModal.Footer>
          <Button type="weak" onClick={() => setModalState(false)} className={styles.pd0}>
            取消
          </Button>
          <Button
            type="primary"
            disabled={
              !!dateErrMsg ||
              !addActivityObj.title ||
              (chargeErr && addActivityObj.access_rule === 0)
            }
            onClick={() => {
              dataReport('e#event_create#next_button#click', {
                paid_classification: addActivityObj?.charge_type - 1,
                create_method: addActivityObj.create_type === 0 ? 0 : 1,
                public_yn: addActivityObj.is_public === 1 ? 1 : 0,
              });
              saveActivity();
            }}
            loading={createLoading}
            className={styles.pd0}
          >
            下一步
          </Button>
        </IllustrationModal.Footer>
      </IllustrationModal>
    </div>
  );
};

export default AddButton;
